<template>
  <div class="page-wrap">

    <!-- Confirm dialog -->
    <transition name="fade">
      <div class="overlay" v-if="showConfirm" @click.self="showConfirm = false">
        <div class="confirm-dialog">
          <div class="cd-icon-wrap">
            <i class="fa fa-map-marker-alt"></i>
          </div>
          <div class="cd-title">Change Location?</div>
          <div class="cd-sub">You're about to move this appointment to:</div>
          <div class="cd-detail-card">
            <div class="cdc-row">
              <i class="fa fa-map-marker-alt"></i>
              <span>{{ selected_item.name }}</span>
            </div>
            <div class="cdc-row muted">
              <i class="fa fa-user"></i>
              <span>{{ getapplicantdetail.fname }} {{ getapplicantdetail.lname }} — #{{ getapplicantdetail.id }}</span>
            </div>
          </div>
          <div class="confirm-footer">
            <button class="btn-cd-cancel" @click="showConfirm = false">
              <i class="fa fa-times"></i> Cancel
            </button>
            <button class="btn-cd-confirm" @click="doSubmit()">
              <i class="fa fa-check"></i> Yes, Change
            </button>
          </div>
        </div>
      </div>
    </transition>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-map-marker-alt"></i></div>
          <div>
            <div class="panel-title">Change Location</div>
            <div class="panel-sub">Select a new location for this appointment</div>
          </div>
        </div>
        <button class="btn-back" @click="goback()">
          <i class="fa fa-arrow-left"></i> Go Back
        </button>
      </div>

      <!-- Applicant info strip -->
      <div class="info-strip">
        <div class="info-chip">
          <span class="ic-label">Appointment #</span>
          <span class="ic-val">{{ getapplicantdetail.id }}</span>
        </div>
        <div class="info-divider"></div>
        <div class="info-chip">
          <span class="ic-label">Applicant</span>
          <span class="ic-val">{{ getapplicantdetail.fname }} {{ getapplicantdetail.lname }}</span>
        </div>
      </div>

      <!-- Error banner -->
      <div class="error-banner" v-if="errorMsg && errorMsg.length">
        <i class="fa fa-exclamation-circle"></i> {{ errorMsg }}
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="dataLoading">
        <i class="fa fa-spinner fa-spin"></i> Loading locations…
      </div>

      <!-- Empty (no locations at all) -->
      <div class="state-box" v-else-if="!dataLoading && locations.length === 0">
        <i class="fa fa-map-marker-alt"></i> No locations available
      </div>

      <!-- Search bar -->
      <div class="loc-search-bar" v-if="!dataLoading && locations.length > 0">
        <i class="fa fa-search"></i>
        <input
          type="text"
          v-model="locationSearch"
          placeholder="Search locations…"
          class="loc-search-input"
        />
        <button class="loc-search-clear" v-if="locationSearch" @click="locationSearch = ''">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- No search results -->
      <div class="state-box" v-if="!dataLoading && locations.length > 0 && filteredLocations.length === 0">
        <i class="fa fa-search"></i> No locations match "{{ locationSearch }}"
      </div>

      <!-- Location grid -->
      <div class="locations-grid" v-else-if="!dataLoading && filteredLocations.length > 0">
        <location-card
          v-for="(location, index) in filteredLocations"
          :key="index"
          :url="base_url"
          :index="index"
          :location="location"
          @locationIndex="locationIndex"
        ></location-card>
      </div>

      <!-- Footer -->
      <div class="panel-footer" v-if="!dataLoading">
        <button class="btn-cancel" @click="goback()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button class="btn-submit" @click="submit()">
          <i class="fa fa-check"></i> Confirm Change
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import LocationCard from "@/components/frontend/locationcard";
import { SET_BREADCRUMB, SET_LOCATION_ID } from "@/core/services/store/mutations.type";
import { LOCATIONS, NEWLOCATIONSTORE } from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  components: { LocationCard },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.fetchLocations();
  },
  data() {
    return {
      errorMsg: "",
      dataLoading: false,
      locations: [],
      base_url: "",
      selected_item: {},
      showConfirm: false,
      locationSearch: "",
      breadCrumbs: [
        { id: 1, title: "Dashboard",        route: "client.dashboard" },
        { id: 2, title: "Appointment List", route: "" },
        { id: 3, title: "Change Location",  route: "" }
      ]
    };
  },
  computed: {
    ...mapGetters(["getLocationId", "getapplicantdetail"]),
    filteredLocations() {
      const q = this.locationSearch.trim().toLowerCase();
      if (!q) return this.locations;
      return this.locations.filter(l =>
        (l.name        && l.name.toLowerCase().includes(q)) ||
        (l.description && l.description.toLowerCase().includes(q))
      );
    }
  },
  methods: {
    goback() {
      this.$store.commit(SET_LOCATION_ID, "");
      this.$router.go(-1);
    },
    locationIndex(index) {
      this.selected_item = this.locations[index];
    },
    submit() {
      if (!this.getLocationId) {
        this.$toastr.e("Please select a location");
        return;
      }
      this.showConfirm = true;
    },
    doSubmit() {
      this.showConfirm = false;
      this.$store.dispatch(NEWLOCATIONSTORE, {
        client_id:  this.getLocationId,
        app_id:     this.$route.params.app_id,
        app_token:  this.$route.params.token
      })
        .then(() => {
          this.$store.commit(SET_LOCATION_ID, "");
          this.$toastr.s("Location changed successfully");
          this.$router.go(-1);
        })
        .catch(() => {});
    },
    fetchLocations() {
      this.dataLoading = true;
      this.$store.dispatch(LOCATIONS, {
        client_id:  this.$route.params.id,
        app_id:     this.$route.params.app_id,
        app_token:  this.$route.params.token
      })
        .then(data => {
          this.locations    = data.data;
          this.base_url     = data.url;
          this.dataLoading  = false;
        })
        .catch(() => { this.dataLoading = false; });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 40px;
  font-family: $font;
}

/* ── Overlay / confirm dialog ── */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(13,27,62,0.4);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.confirm-dialog {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(13,27,62,0.18);
  width: 100%;
  max-width: 380px;
  overflow: hidden;
  animation: pop-in 0.2s ease;
}

@keyframes pop-in {
  from { transform: scale(0.92); opacity: 0; }
  to   { transform: scale(1);    opacity: 1; }
}

.cd-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 24px 8px;

  i {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #dbeafe;
    color: $blue;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}

.cd-title {
  font-size: 16px;
  font-weight: 700;
  color: $dark;
  text-align: center;
  padding: 10px 24px 4px;
}

.cd-sub {
  font-size: 12.5px;
  color: #7a8499;
  text-align: center;
  padding: 0 24px 16px;
}

.cd-detail-card {
  margin: 0 20px 20px;
  background: #f5f8fe;
  border: 1px solid #e0e8f7;
  border-radius: 10px;
  overflow: hidden;
}

.cdc-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #e8edf5;
  font-size: 13px;
  font-weight: 600;
  color: $dark;

  &:last-child { border-bottom: none; }
  &.muted { color: #7a8499; font-weight: 400; }

  i { width: 16px; text-align: center; color: $blue; font-size: 12px; flex-shrink: 0; }
}

.confirm-footer {
  display: flex;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid #eef0f8;
  background: #fafbfd;

  .btn-cd-cancel {
    flex: 1;
    height: 38px;
    border: 1.5px solid $border;
    background: #fff;
    color: #4a5568;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.15s;

    &:hover { border-color: #e53e3e; color: #e53e3e; }
  }

  .btn-cd-confirm {
    flex: 1;
    height: 38px;
    border: none;
    background: $blue;
    color: #fff;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: opacity 0.15s;

    &:hover { opacity: 0.9; }
  }
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to           { opacity: 0; }

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13,27,62,0.07);
  overflow: hidden;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 12px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  background: #fff;
  color: #4a5568;
  border: 1.5px solid $border;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { border-color: $blue; color: $blue; }
}

/* ── Info strip ── */
.info-strip {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background: #f5f8fe;
  border-bottom: 1px solid #e8edf5;
  flex-wrap: wrap;
  gap: 16px;
}

.info-chip {
  display: flex;
  align-items: center;
  gap: 8px;

  .ic-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; color: #a0aab8; }
  .ic-val   { font-size: 13px; font-weight: 600; color: $dark; }
}

.info-divider { width: 1px; height: 20px; background: #dde4f5; }

/* ── Error ── */
.error-banner {
  margin: 14px 20px 0;
  padding: 10px 14px;
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 8px;
  color: #c62828;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── States ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  i { font-size: 16px; }
}

/* ── Search bar ── */
.loc-search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid #eef0f8;
  background: #fafbfd;

  > i {
    color: #a0aab8;
    font-size: 12px;
    flex-shrink: 0;
  }

  .loc-search-input {
    height: 34px;
    width: 100%;
    max-width: 320px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    outline: none;
    background: #fff;
    transition: border-color 0.15s;

    &::placeholder { color: #b0bac9; }
    &:focus { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
  }

  .loc-search-clear {
    border: none;
    background: transparent;
    color: #a0aab8;
    cursor: pointer;
    font-size: 11px;
    padding: 0;
    line-height: 1;
    flex-shrink: 0;

    &:hover { color: $dark; }
  }
}

/* ── Location grid ── */
.locations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
  padding: 20px;
}

/* ── Footer ── */
.panel-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  background: #fafbfd;
  border-top: 1px solid #eef0f6;
}

.btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 18px;
  background: #fff;
  color: #4a5568;
  border: 1.5px solid $border;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { border-color: #e53e3e; color: #e53e3e; }
}

.btn-submit {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 22px;
  background: $blue;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover { opacity: 0.9; }
}
</style>
